import { useContext, useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import "../../css/wallet/transaction.css";
import { useTranslation } from "react-i18next";
import { getCookie } from "../../App.js";
import { TransactionRequest } from "./Transaction/TransactionRequest.js";
import { AuthContext } from "../SessionChecker/SessionChecker.js";
import { withdrawalConfirmationRequest } from "./Transaction/WithdrawalConfirmationRequest.js";

function Transaction({ theme }) {
  const { link } = useParams();
  const [data, setData] = useState();
  const [loadingStatus, setLoadingStatus] = useState(false);
  const { t } = useTranslation();

  const { currentUserUsername } = useContext(AuthContext);

  const [memoInputValue, setMemoInputValue] = useState("");
  const [statusInputValue, setStatusInputValue] = useState("");

  const navigate = useNavigate();

  useEffect(() => {
    const request = async () => {
      await TransactionRequest(link, setData, setLoadingStatus);
    };
    request();
  }, [link]);

  return !loadingStatus ? (
    <div></div>
  ) : (
    <div className="mainDiv"> 
      <div className={`headerDiv ${theme}`}>{t("Transaction")}</div>
      <div className="contentDiv padding12 gap12">
        <div className="tokenIconDiv">
          {data.token && data.token == "Toman" ? (
            <img src="/icons/toman.png"></img>
          ) : data.token == "USDT" ? (
            <img src="/icons/usdt.png"></img>
          ) : data.token == "TRX" ? (
            <img src="/icons/trx.png"></img>
          ) : data.token == "GRAM" ? (
            <img src="/icons/gram.png"></img>
          ) : (
            ""
          )}

          {data.sended_token &&
            (data.sended_token == "Toman" ? (
              <img src="/icons/toman.png"></img>
            ) : data.sended_token == "USDT" ? (
              <img src="/icons/usdt.png"></img>
            ) : data.sended_token == "TRX" ? (
              <img src="/icons/trx.png"></img>
            ) : null)}

          {data.transaction_type == "Swap" && <div>{t("to")}</div>}

          {data.received_token &&
            (data.received_token == "Toman" ? (
              <img src="/icons/toman.png"></img>
            ) : data.received_token == "USDT" ? (
              <img src="/icons/usdt.png"></img>
            ) : data.received_token == "TRX" ? (
              <img src="/icons/trx.png"></img>
            ) : null)}
        </div>

        {data.amount && (
          <div className="transactionAmountDiv">
            {data.transaction_type == "Deposit" ||
            data.transaction_type == "Receive" ||
            data.receiver == currentUserUsername
              ? "+" + data.amount.toLocaleString("en-US")
              : data.transaction_type == "Withdrawal" ||
                  data.transaction_type == "Send" ||
                  data.sender == currentUserUsername
                ? "-" +
                  data.amount.toLocaleString("en-US") +
                  " " +
                  t(data.token)
                : null}
          </div>
        )}

        {data.sended_amount && data.received_amount && (
          <div className="transactionAmountDiv">
            {data.transaction_type == "Swap"
              ? data.sended_amount.toLocaleString("en-US") +
                t(" Sended ") +
                data.received_amount.toLocaleString("en-US") +
                t(" Received ")
              : null}
          </div>
        )}

        <div className={`transactionInfoDiv ${theme}`}>
          {data.date && (
            <div className="transactionInfoDiv2">
              <div className="transactionInfoDiv3">{t("Date")}</div>
              <div className="transactionInfoDiv4">{data.date}</div>
            </div>
          )}

          {data.shamsi_date && (
            <div className="transactionInfoDiv2">
              <div className="transactionInfoDiv3">{t("Date")}</div>
              <div className="transactionInfoDiv4">{data.shamsi_date}</div>
            </div>
          )}

          {data.status && (
            <div className="transactionInfoDiv2">
              <div className="transactionInfoDiv3">{t("Status")}</div>
              <div className="transactionInfoDiv4">
                {data.status == "Completed"
                  ? t("Completed")
                  : data.status == "Waiting"
                    ? t("Waiting")
                    : data.status == "Rejected"
                      ? t("Rejected")
                      : null}
              </div>
            </div>
          )}

          {data.value_in_dollars != undefined && (
            <div className="transactionInfoDiv2">
              <div className="transactionInfoDiv3">{t("Value in Dollars")}</div>
              <div className="transactionInfoDiv4">{data.value_in_dollars}</div>
            </div>
          )}

          {data.bank_card && (
            <div className="transactionInfoDiv2">
              <div className="transactionInfoDiv3">{t("Bank Card")}</div>
              <div className="transactionInfoDiv4">{data.bank_card}</div>
            </div>
          )}

          {data.receiving_address !== undefined && (
            <div className="transactionInfoDiv2">
              <div className="transactionInfoDiv3">
                {t("Recipient Address")}
              </div>
              <div className="transactionInfoDiv4">
                {data.receiving_address}
              </div>
            </div>
          )}

          {data.transaction_link && (
            <div className="transactionInfoDiv2">
              <div className="transactionInfoDiv3">{t("Transaction Link")}</div>
              <div className="transactionInfoDiv4">{data.transaction_link}</div>
            </div>
          )}

          {data.fee !== undefined && (
            <div className="transactionInfoDiv2">
              <div className="transactionInfoDiv3">{t("fee")}</div>
              <div className="transactionInfoDiv4">
                {data.fee.toLocaleString("en-US")}
              </div>
            </div>
          )}

          {data.sender && (
            <div className="transactionInfoDiv2">
              <div className="transactionInfoDiv3">{t("Sender")}</div>
              <div className="transactionInfoDiv4">{data.sender}</div>
            </div>
          )}

          {data.receiver && (
            <div className="transactionInfoDiv2">
              <div className="transactionInfoDiv3">{t("Receiver")}</div>
              <div className="transactionInfoDiv4">{data.receiver}</div>
            </div>
          )}

          {data.memo && (
            <div className="transactionInfoDiv2">
              <div className="transactionInfoDiv3">{t("memo")}</div>
              <div className="transactionInfoDiv4 memo">{data.memo}</div>
            </div>
          )}

          {currentUserUsername == "hiket" &&
            data.transaction_type == "Withdrawal" && (
              <>
                <input
                  placeholder="Memo"
                  onChange={(e) => {
                    setMemoInputValue(e.target.value);
                  }}
                ></input>
                <input
                  placeholder="Status"
                  onChange={(e) => {
                    setStatusInputValue(e.target.value);
                  }}
                ></input>
                <button
                  onClick={() => {
                    withdrawalConfirmationRequest(
                      navigate,
                      data.id,
                      memoInputValue,
                      statusInputValue,
                    );
                  }}
                >
                  Submit
                </button>
              </>
            )}
        </div>
      </div>
    </div>
  );
}

export default Transaction;
